import { BulkRequestFilterContext, useBulkRequestFilterContext } from "./bulkRequestFilterContext";
import { BulkRequestFilterForm } from "./BulkRequestFilterForm";
import { PatientSearch } from "molecules/filters/PatientSearch/PatientSearch";
import { TablePopoverFilter } from "molecules/filters/TableFilter/TablePopoverFilter";
import { getFilterByText } from "./BulkRequestFilterTags";
import { useBulkRequestFilter } from "./useBulkRequestFilter";
import { useMemo, useState } from "react";

interface BulkRequestFilterContextProviderProps extends Readonly<React.PropsWithChildren> {
    readonly agingIndex: number | null;
}

/** Bulk request filter context provider. */
export const BulkRequestFilterContextProvider = ({ children, agingIndex }: BulkRequestFilterContextProviderProps) => {
    const { state, dispatch, filter } = useBulkRequestFilter(agingIndex);
    const memoizedValue = useMemo(() => Object.freeze({ state, dispatch, filter }), [state, dispatch, filter]);

    return <BulkRequestFilterContext value={memoizedValue}>{children}</BulkRequestFilterContext>;
};

/** Bulk request filtering toolbar that's shown atop the table. */
export const BulkRequestFilterBar = () => {
    const [open, setOpen] = useState(false);
    const { state, dispatch, filter } = useBulkRequestFilterContext();

    const content = <BulkRequestFilterForm state={state} dispatch={dispatch} onClose={() => setOpen(false)} />;

    return (
        <>
            <PatientSearch
                patientSearchFilter={state.patient}
                setPatientSearchFilter={(value) => dispatch({ type: "PatientAction", value })}
            />
            <TablePopoverFilter buttonText={getFilterByText(filter)} content={content} open={open} setOpen={setOpen} />
        </>
    );
};
